import { ready } from "@/lib/ready";
import { loadJq } from "@/lib/loadJq";
import { lazyLoad } from "@/lib/lazyLoad";
import { loadCSS } from "@/lib/loadCSS";
import { loadJs } from "@/lib/loadJs";
import "@/share/loading";
import Broweser from "@/lib/browser"
import { debounce } from "@/lib/debounce";
import dialog, { Alert, Confirm } from "@/lib/easy-dialog"
import { removeCouponCode } from "./coupon";
import { addStyle } from "@/lib/dom/addStyle";
import { onlyNumber, isValidPhone } from "@/lib/utils";
import { CopyCouponCode, onPromoClick } from "./copy-coupon"



/**
 * 发送GA统计数据
 * @param {any} eventCategory
 * @param {any} eventAction
 * @param {any} eventLabel
 */
const SendGAEvent = (eventCategory: string, eventAction: string, eventLabel: string) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "common_event",
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel
    });
  }
}

Object.assign(globalThis, {
  loadCSS: loadCSS,
  loadJq: loadJq,
  loadJs: loadJs,
  ready: ready,
  lazyLoad: lazyLoad,
  Browser: Broweser,
  debounce: debounce,
  CopyCouponCode,
  onPromoClick,
  SendGAEvent: SendGAEvent,
  Alert,
  RemoveCouponClipped: removeCouponCode,
  Confirm,
  CountryCurrency: '$',
  IsValidPhone: isValidPhone,
  easyDialog: {
    open: dialog.open,
    close: dialog.close
  },
  Utils: {
    OnlyNumber: onlyNumber
  },
  Input: (elmt: HTMLInputElement) => {
    if (!Broweser.isSmall()) {
      if (elmt.value == '') {
        elmt.placeholder = 'Search by Keywords, Brand or Item #';
      }
    }
  },
  FooterEmailClear: (elmt: HTMLInputElement) => {

    if (elmt.value == '') {
      elmt.setAttribute('placeholder', '');
    }
  },
  FooterEmailInput: (elmt: HTMLInputElement) => {
    if (elmt.value == '') {
      elmt.setAttribute('placeholder', 'Enter your email address');
    }
  },
  PreviewLargeImage: (imgUrl: string, productID: string, productName: string, productLink: string) => {

    // use css from "@/share/loading"; 
    const loading = `<div>
    <div class='loading-spinner' style='height: 42px;'>
    <svg viewBox='25 25 50 50' class='circular'><circle cx='50' cy='50' r='20' fill='none' class='path'></circle></svg></div>
    </div>`
    dialog.open({
      html: loading
    })

    const img = new Image()
    img.onload = (evt) => {
      const content = `<div class="testimonial-popup">
            <a href="javascript:;" title="close" class="close_btn" id="closeBtn" data-close=""></a>
            <div class="product-info">${productID && productName && productLink ? `<div>${productName}<span>Item# <a href="${productLink}">${productID}</a><span></div>` : ''}</div>
            <div style="text-align: center;"><img src="${imgUrl}" class="img-fluid"></div>
            </div>
        <style>
          .testimonial-popup {
            border-radius: 20px;
            background-color: #fff;
            position: relative;
            padding: 0 40px 40px 40px;
          }

          .testimonial-popup .close_btn {
            background-image: url(https://static.anypromo.com/jscripts/fancybox/source/fancybox_sprite.png);
            position: absolute;
            top: -18px;
            right: -18px;
            width: 36px;
            height: 36px;
            cursor: pointer;
            z-index: 8040;
          }

          .testimonial-popup img {
            max-width: 600px;
            max-height: 600px;
          }

          .testimonial-popup .product-info {
            font-size: 18px;
            height: 40px;
            display: flex;
            align-items: center;
            color: #000;
            line-height: 1;
          }

          .testimonial-popup .product-info span {
            font-size: 13px;
            color: #666;
            padding-left: 10px;
          }

          @media (max-width:800px) {
            .testimonial-popup {
              padding: 30px;
            }

            .testimonial-popup img {
              max-width: 100%;
            }
          }
  </style>`;

      dialog.open({
        container: {
          content: content
        }
      })

      const easyDialogBox = document.querySelector("#easyDialogBox");

      addStyle(easyDialogBox?.querySelectorAll(".easyDialog_wrapper,.easyDialog_wrapper .easyDialog_content") as NodeListOf<HTMLElement>, "border-radius", "20px")
      addStyle(easyDialogBox?.querySelectorAll(".easyDialog_wrapper .easyDialog_text") as NodeListOf<HTMLElement>, "padding", "0")
    }

    img.src = imgUrl
  }
})


export { }
